const Component = () => import('./WhoAreYouShoppingFor');

export { Component };
